import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(MessageService);
  return next(req).pipe(
    catchError(err => {
      //Ignore Graph API Photo 404, 503 error
      const graphPhotoError = (err.status === 404 || err.status === 503) && err.url?.includes('me/photo/$value');

      if (!graphPhotoError) {
        toast.add({
          severity: 'error',
          summary: `${err.status === 0 ? 'Network:' : err.status} ${err.statusText}`,
          detail: `${err.url} \r\n ${err.error.message}`,
          key: 'main',
          life: 5000
        });
      }
      // return the error so a client level handler can catch it
      return throwError(() => err);
    })
  )
};
